import * as UI from "@accurx/design";
import styled from "styled-components";

export const StyledNotificationPopoverItem = styled(UI.PopoverItem)`
    padding: 0.25rem 0.25rem 0.5rem 0.25rem;
    margin: 0;
    display: block;

    * {
        margin-left: 0;
    }
`;
